import React from "react";

import ProjectsEnquiry from "src/modules/ProjectsEnquiry/ProjectsEnquiry";

const ProjectsEnquiryMain = () => {
  return (
    <div className="p-10">
      <ProjectsEnquiry />
    </div>
  );
};

export default ProjectsEnquiryMain;
